import useUserStore from '../../Stores/UserStore';

const API_KEY = import.meta.env.VITE_GOOGLE_TRANSLATE_API_KEY;

export default function TranslateBanner() {
  const langCode = useUserStore((s) => s.appLanguage ?? 'en');

  if (!import.meta.env.DEV) return null;
  if (langCode === 'en') return null;
  if (API_KEY) return null;

  return (
    <div
      style={{
        background: '#c0392b',
        color: 'white',
        padding: '8px 16px',
        fontSize: '13px',
        textAlign: 'center',
      }}
    >
      Translation disabled: Add VITE_GOOGLE_TRANSLATE_API_KEY to .env and restart the dev server.
    </div>
  );
}
